import type { FastFeedDailyRow, FastFeedSummary } from "@/api/types";
import { KpiTile } from "@/components/ui";
import { compact } from "@/lib/formatters";
import { Sparkline } from "@/lib/sparkline";

function formatUsdg(v: number): string {
  if (v >= 1_000_000) return `$${(v / 1_000_000).toFixed(2)}M USDG`;
  if (v >= 1_000) return `$${(v / 1_000).toFixed(2)}K USDG`;
  return `$${v.toFixed(2)} USDG`;
}

interface FastFeedKpiStripProps {
  summary: FastFeedSummary | undefined;
  daily: FastFeedDailyRow[];
  loading: boolean;
}

export function FastFeedKpiStrip({ summary, daily, loading }: FastFeedKpiStripProps) {
  return (
    <div className="grid-6" style={{ marginBottom: 8 }}>
      <KpiTile
        label="TOTAL REVENUE"
        value={summary ? formatUsdg(summary.total_revenue_usdg) : "—"}
        subtext="all-time USDG"
        loading={loading}
      >
        <Sparkline data={daily.map((d) => d.revenue_usdg)} />
      </KpiTile>

      <KpiTile
        label="TREASURY SHARE"
        value={summary ? formatUsdg(summary.treasury_total_usdg) : "—"}
        subtext="97% → DAO Treasury"
        loading={loading}
      />

      <KpiTile
        label="GUILD SHARE"
        value={summary ? formatUsdg(summary.guild_total_usdg) : "—"}
        subtext="3% → Dev Guild"
        loading={loading}
      />

      <KpiTile
        label="TICKETS SOLD"
        value={summary ? compact(summary.total_tickets_sold) : "—"}
        subtext="all-time"
        loading={loading}
      >
        <Sparkline data={daily.map((d) => d.tickets_sold)} color="var(--color-green)" />
      </KpiTile>

      <KpiTile
        label="UNIQUE BUYERS"
        value={summary ? compact(summary.total_unique_buyers) : "—"}
        subtext="all-time"
        loading={loading}
      >
        <Sparkline data={daily.map((d) => d.new_buyer_count)} color="var(--color-green)" />
      </KpiTile>

      <KpiTile
        label="AVG TICKET"
        value={summary ? formatUsdg(summary.avg_ticket_usdg) : "—"}
        subtext="per purchase"
        loading={loading}
      />
    </div>
  );
}
